import React, {useEffect} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {useTheme} from '@mui/styles'

import {connect} from 'react-redux'
import { 
  showAlert,
  createAccount, 
  resetFormState,
  formSubmittedWithErrors
} from '../../actions'

import {useIsMounted} from '../../hooks'
import {defaultAddress} from '../../helpers'
import {getTopAddress, getBottomAddress, formatError} from '../../utils'

import * as Yup from 'yup'
import {withFormik, Form, Field} from 'formik'

import {GooglePlacesField, Errors, ThreeDotProgress} from '../generics'

import Button from '@mui/material/Button'




const cssStyles = props => ({
  root: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 200px;
  `,
  addressContainer: css`
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 4px;
    border: solid 1px black;
    min-height: 60px;
    background-color: #fff;
  `,
  venue: css`
    font-weight: 700;
  `,
  errorContainer: css`
    min-height: 30px;
  `,
  buttonContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  `,
  button: css`
    width: 100%;
    height: 44px;
    color: #fff;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 5px;
    font-size: 0.9rem;
    background-color: ${props.theme.palette.primary.main};

    &:disabled {
      background-color: #000;
      opacity: 0.3;
    }
  `
})




const AccountVenueForm = props => {

  const isMounted = useIsMounted()

  const theme = useTheme()

  const styles = cssStyles({theme})

  const { 
    values,
    errors,
    setErrors,
    formStatus,
    formErrors,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    resetFormState
  } = props


  const unlistedErrors = (errors && errors.unlisted) ? errors.unlisted : []

  useEffect(() => {
    if (values.location_service_id) {
      setFieldValue('name', values.location)
    }
  }, [setFieldValue, values.location, values.location_service_id])



  useEffect(() => {
    if (isMounted.current) {
      if (formStatus === 'error') {
        setErrors(formErrors)
      }
    }
    return () => resetFormState()
  }, [
    isMounted, 
    setErrors,
    formStatus, 
    formErrors, 
    resetFormState
  ])


  function handleFocus(e) {
    if (Object.keys(errors).length > 0 && !e.target.value) {
      setFieldValue('location', '', false)
      setFieldTouched('location', false)
      setFieldValue('address', defaultAddress, false)
    }
  }



  return (
    <div css={styles.root}>
      <div css={styles.errorContainer}>
        {Boolean(unlistedErrors.length) && <Errors errors={unlistedErrors} />}
      </div>

      <Form>
        <Field
          fullWidth
          label='Venue'
          name='location'
          variant='filled'
          onFocus={handleFocus}
          component={GooglePlacesField}
          helperText='Search for your venue above and select it from the dropdown.'
          placeholder='Venue name, address, or location...'
        />

        {values.location_service_id && 
          <div css={styles.addressContainer}>
            <p css={styles.venue}>{values.location}</p>
            <p>{getTopAddress(values.address)}</p>
            <p>{getBottomAddress(values.address)}</p>
          </div>
        }

        <div css={styles.buttonContainer }>
          <Button 
            type='submit'
            css={styles.button}
            disabled={isSubmitting || !values.location_service_id}
          >
            {isSubmitting ? <ThreeDotProgress color='#fff' radius={5} /> : 'Create'}
          </Button>
        </div>
      </Form>
    </div>
  )
}



const EnhancedVenueForm = withFormik({
  mapPropsToValues: () => {
    return {
      name: '',
      location: '',
      coordinates: '',
      location_service: '', 
      location_service_id: '',
      address: defaultAddress
    }
  },

  validationSchema: Yup.object().shape({
    name: Yup.string().required('required').max(60),
    location: Yup.string().required('required'),
    coordinates: Yup.string('required')
  }),

  handleSubmit: (values, formikBag) => {
    const {setSubmitting} = formikBag

    const {
      callback,
      showAlert, 
      createAccount, 
      formSubmittedWithErrors
    } = formikBag.props


    const form = new FormData()
    form.append('name', values.location)
    form.append('location', values.location)
    form.append('coordinates', values.coordinates)
    form.append('location_service', values.location_service)
    form.append('location_service_id', values.location_service_id)
    form.append('address', JSON.stringify(values.address))
    form.append('type', 'venue')


    createAccount(form).then(response => {
      callback?.()
      setSubmitting(false)
      showAlert('Congratulations! Your venue account has been created', 'success')
    })
    .catch(error => {
      values.coordinates = ''
      error = formatError(error)

      setSubmitting(false)
      formSubmittedWithErrors(error.messages, {})
    })
  }
})(AccountVenueForm)



const mapStateToProps = state => {
  return {
    formStatus: state.form.status,
    formErrors: state.form.errors
  }
}


const actions = {
  showAlert,
  createAccount,
  resetFormState,
  formSubmittedWithErrors
}

export default connect(mapStateToProps, actions)(EnhancedVenueForm)







